<h1 mat-dialog-title i18n>
	Accept Legal <small class="align-top">- {{dialogData.user.email}}</small>
</h1>

<form [formGroup]="formInputs">
	<div mat-dialog-content class="main-content">
		<div class="row">
			<div class="col-12">
				<mat-form-field appearance="standard" class="w-100 hover-suffix user-term-accept__term-id">
					<mat-label i18n>Legal ID/Alias</mat-label>
					<input matInput type="text" placeholder="ID" i18n-placeholder formControlName="id"/>
					<mat-error
						appFormErrorMessage
						[type]="formEditorInputType.text"
						[errorFormControl]="formInputs.controls.id"
					></mat-error>
					<mat-icon
						matSuffix
						class="suffix-icon"
						aria-hidden="false"
						aria-label="icon displays a tooltip when focused or hovered over"
						matTooltip="The ID of the legal to accept. Only legals from companies you are currently and administrator for is accepted."
						i18n-matTooltip
					>info</mat-icon>
				</mat-form-field>
			</div>
		</div>
	</div>

	<div mat-dialog-actions class="row mb-0">
		<div class="col-6 text-center">
			<button
				class="w-100"
				mat-flat-button
				mat-dialog-close
				i18n
				cdkFocusInitial
			>Cancel</button>
		</div>
		<div class="col-6 text-center">
			<button
				class="w-100"
				type="submit"
				mat-flat-button
				color="primary"
				[disabled]="!formInputs.valid"
				i18n
				cdkFocusInitial
				(click)="confirmAcceptTerm()"
			>Save</button>
		</div>
	</div>
</form>
